import { ChartFooter, ProjectedChart } from "@components/ProjectedChart";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { ProjectedChartProvider } from "@contexts";
import { SipFrequency } from "@ctypes";
import { useDynamicChartWidth, useTheme } from "@hooks";
import { spacing } from "@layout";
import { ProjectedChartHeader } from "./ProjectedChartHeader";
import { useStyles } from "./styles";
import { ProjectionBreakdownProps } from "./types";

const CHART_HEIGHT = 390;

export const ProjectionBreakdown = ({
  numberOfYearsActive,
  annualDeposit,
  contributeAfter18,
  multiplier,
  projectionLength,
  showInvestmentAmounts = true,
  initialBalance = 0,
}: ProjectionBreakdownProps) => {
  const { theme } = useTheme();
  const styles = useStyles();

  const { width } = useDynamicChartWidth();

  const barChartWidth = width + spacing.m;

  return (
    <ProjectedChartProvider
      initialBalance={initialBalance}
      currentAge={numberOfYearsActive}
      projectedAge={projectionLength}
      recurringAmount={annualDeposit}
      frequency={SipFrequency.Annually}
      multiplier={multiplier}
      contributeAfter18={contributeAfter18}
      width={barChartWidth}
      barChartWidth={barChartWidth}
      height={CHART_HEIGHT}
      investedColor={theme.chart.projection.inverted.invested}
      returnedColor={theme.chart.projection.inverted.returned}
      showInvestmentAmounts={showInvestmentAmounts}
      invertedTheme
    >
      <ProjectedChart
        header={<ProjectedChartHeader />}
        footer={
          <>
            <Spacing size={SpacingSizes.XXXL} />
            <ChartFooter />
          </>
        }
        style={styles.container}
      />
    </ProjectedChartProvider>
  );
};
